import { useTheme } from '../../context/ThemeContext.jsx';

function RailIcon({ title, active = false, onClick, children }) {
  const { theme } = useTheme();
  return (
    <button
      onClick={onClick}
      title={title}
      style={{
        width: 32, height: 32, border: `1px solid ${active ? theme.accent : theme.borderMedium}`,
        background: active ? theme.accentBg : 'none',
        color: active ? theme.accent : theme.textMuted,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 14, cursor: 'pointer', fontFamily: 'inherit', padding: 0,
      }}
    >{children}</button>
  );
}

export default function Rail({
  onToggleTheme, onToggleMenu, userInitials,
  showFavorites, showMyFonts, favCount,
  onShowFavorites, onShowMyFonts, onShowUpload,
  onShowGoogleBrowser, onShowAdobeBrowser, onShowBrandKits,
}) {
  const { theme, isDark } = useTheme();

  return (
    <nav style={{
      width: '6rem', flexShrink: 0, borderRight: `1px solid ${theme.border}`,
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      padding: '22px 0 20px', gap: 18, position: 'sticky', top: 0, height: '100vh',
    }}>
      <div
        onClick={onToggleMenu}
        title="Menu"
        style={{ width: 18, display: 'flex', flexDirection: 'column', gap: 4, cursor: 'pointer', padding: '4px 0' }}
      >
        <b style={{ display: 'block', height: 2, background: theme.text }} />
        <b style={{ display: 'block', height: 2, background: theme.text }} />
        <b style={{ display: 'block', height: 2, background: theme.text }} />
      </div>

      <div style={{
        writingMode: 'vertical-rl', transform: 'rotate(180deg)',
        fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase',
        color: theme.textFaint, marginTop: 24,
      }}>font vault</div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
        <RailIcon title={`Favorites (${favCount})`} active={showFavorites} onClick={onShowFavorites}>&#9733;</RailIcon>
        <RailIcon title="My Fonts" active={showMyFonts} onClick={onShowMyFonts}>&#9679;</RailIcon>
        <RailIcon title="Add Fonts" onClick={onShowUpload}>+</RailIcon>
        <div style={{ width: 20, height: 1, background: theme.borderLight, margin: '4px 0' }} />
        <RailIcon title="Google Fonts" onClick={onShowGoogleBrowser}>G</RailIcon>
        <RailIcon title="Adobe Fonts" onClick={onShowAdobeBrowser}>A</RailIcon>
        <RailIcon title="Brand Kits" onClick={onShowBrandKits}>&#9670;</RailIcon>
      </div>

      <div style={{ flex: 1 }} />

      <div
        onClick={onToggleTheme}
        title="Toggle theme"
        style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}
      >
        <span style={{ width: 30, height: 16, border: `1px solid ${theme.borderMedium}`, position: 'relative', display: 'block' }}>
          <span style={{
            position: 'absolute', top: 1, left: 1, width: 12, height: 12,
            background: theme.accent, transform: `translateX(${isDark ? '14px' : '0px'})`,
            transition: 'transform 200ms ease-in-out',
          }} />
        </span>
        <span style={{ fontSize: 9, letterSpacing: '0.14em', textTransform: 'uppercase', color: theme.textFaint }}>
          {isDark ? 'dark' : 'light'}
        </span>
      </div>

      <div style={{
        width: 30, height: 30, border: `1px solid ${theme.borderMedium}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 10, letterSpacing: '0.06em', color: theme.text,
      }}>{userInitials || '??'}</div>
    </nav>
  );
}
